import {concatUrl} from '@/service/base'
import {appRequest} from '@/service/request'
import store from '@/store'
import {EventId as eventId} from '@/util/constants'



const clientCheckUrl = concatUrl('/client/checkClient')

export async function clientCheck(name, phone) {
  return await appRequest(clientCheckUrl, {
    method: 'POST',
    body: JSON.stringify({eventId, name, phone}),
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
const DefaultHeaders = {
  'Content-Type': 'application/json;charset=UTF-8',
  // 'token': store.state.base.token
}

// 2、通过客户id查询已经填写的问卷内容 /client/queryResult
export async function queryResult(data) {
  return await appRequest(concatUrl('/client/queryResult'), {
    method: 'POST',
    body: JSON.stringify({eventId, ...data}),
    headers: DefaultHeaders
  })
}

//客户保存\更新问卷信息 /client/operateResult
const operateResultUrl = concatUrl('/client/operateResult')

export async function updateClientResult(data) {
  return await appRequest(operateResultUrl, {
    method: 'POST',
    body: JSON.stringify({eventId, ...data}),
    headers:DefaultHeaders
  })
}

/**
 * 获取活动截止时间
 * @param event_id
 * @returns {Promise<*>}
 */
export async function getExpirationTime() {
  return await appRequest(concatUrl(`/giftCard/getExpirationTime?event_id=${eventId}`), {
    method: 'Get',
  })
}

// 获取会议图片
export function getMeetingPicture() {
  return concatUrl(`/client/getMeetingPicture?eventId=${eventId}`);
  // const body = new FormData();
  // body.append("eventId", eventId);
  // return await appRequest(concatUrl('/client/getMeetingPicture'), {
  //   method: 'POST',
  //   body,
  //   headers: {}
  // })
}

// 获取是否可以编辑
export async function checkCanEdit() {
  const body = new FormData();
  body.append("eventId", eventId);
  return await appRequest(concatUrl('/client/checkCanEdit'), {
    method: 'POST',
    body,
    // body: JSON.stringify({eventId}),
    headers: {}
  })
}
